import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { Select, FormControl, Menu } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';

const CssSelect = withStyles({
  "& .MuiFilledInput-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "36px",
    color: '#8987A2',
  },

  root: {
    width: "100%",
    color: '#8987A2',
    padding: '14px 16px 15px',

    "& label.MuiInputLabel-filled": {
      color: "#8987A2",
      transform: "translate(16px, 15px) scale(1)",

      "&.Mui-error": {
        color: "#F87777"
      },
    },

    "& label.Mui-focused": {
      color: "#8987A2"
    },
  },
})(Select);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",

    "& .MuiFilledInput-root": {
      backgroundColor: '#FFF',
      borderRadius: "36px",
    },

    "& .MuiFilledInput-underline:before": {
      content: 'none'
    },

    "& .MuiSelect-filled.MuiSelect-filled": {
      paddingRight: '52px',
    },

    "& .MuiSelect-select:focus": {
      backgroundColor: 'transparent',
    },
  },

  MenuStyles: {
    "& .MuiMenu-paper": {
      borderRadius: '16px'
    },

    "& .Mui-selected": {
      backgroundColor: '#F6F6FB80'
    }
  },

  MenuItem: {
    color: '#8987A2',
    lineHeight: '36px',
  }
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <FormControl className={classes.root} noValidate>
      {/* <CustomTooltip title={props.tooltip}> */}
      <CssSelect
        size="small"
        label={props.label}
        variant="filled"
        type={props.type}
        error={props.error}
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.func}
        hint={props.hint}
        MenuProps={{ className: classes.MenuStyles }}
        InputProps={{
          disableUnderline: true,
          type: "text",
        }}
      >
        {props?.data?.map(el => {
          return (
            <MenuItem key={el.id} value={el.id} className={classes.MenuItem}>
              {el.name}
            </MenuItem>
          )
        })}
      </CssSelect>
      {/* </CustomTooltip> */}
    </FormControl>
  );
}